const prod = {
  url: "", //process.env.REACT_APP_PUBLISH_PATH,
  //url: process.env.REACT_APP_Login_PATH,
};
const dev = {
  url: "",
};

export const { url } = process.env.NODE_ENV === "development" ? dev : prod;

export const getAPI = url + "get api";

//customer
export const getCustomerDataByIdUrl =
  url + "/api/customers/getCustomerDataById";
export const getCustomerDataUrl = url + "/api/customers/getCustomerData";
export const insertUpdateCustomerDataUrl =
  url + "/api/customers/insertUpdateCustomerData";

export const GetDropDownList = url + "/api/CommonDropdown/GetDropdownList";
export const GetIsUnplannedReasonsList =
  url + "/api/CommonDropdown/GetIsUnplannedDropdownList"; //prashant

export const InsertUpdateTask = url + "/api/Task/InsertAndUpdateTask";
export const checkForEngagementLead = url + "/api/Task/CheckEngagementLead"; //Prashant
export const FileDownloadTask = `${url}/api/ManagerDashboard/DownloadFileFromSharePointTask`;//kausher
export const getTaskDownloadData = `${url}/api/Task/GetTaskDetailsForDownload` //added by kausher
export const InsertUpdateTicketData =
  url + "/api/Ticket/InsertUpdateTicketDetails";
export const CustomerExportToExcel = url + "/api/Common/CommonExportToExcel";

export const TimesheetTotalHours = `${url}/api/Ticket/TimesheetTotalHours`;

//leave request
export const getLeaveRequestMasterGridData =
  url + "/api/LeaveRequest/GetLeaveReqMasterMasterGridData";
export const InsertUpdateLeaveRequestData =
  url + "/api/LeaveRequest/insertUpdateLeaveRequestMasterData";
export const getUnplannedLeaveStatus = 
  url + "/api/LeaveRequest/GetUnplannedLeaveStatus";
export const getLeaveRequestDataById =
  url + "/api/LeaveRequest/GetLeaveRequestMasterById";
export const getEmployeeAvailableLeaveBalance =
  url + "/api/employeeMaster/GetEmployeeAvailableLeaveBalance";
export const getEmployeeReportingManager =
  url + "/api/employeeMaster/GetEmployeeReportingManager";
export const leaveExportToExcel = url + "/api/LeaveRequest/LeaveExportToExcel";
export const getPendingLeavesById =
  url + "/api/LeaveRequest/getPendingLeavesById";
export const EmployeeAvailableLeaveBalance =
  url + "/api/LeaveRequest/EmployeeAvailableLeaveBalance";
export const getLeaveTypes = url + "/api/LeaveRequest/getLeaveTypes";
export const getLeaveConfigData = url + "/api/LeaveRequest/getLeaveConfig";
export const getLastAppliedLeave =
  url + "/api/LeaveRequest/getLastAppliedLeave";

  export const getLongLeaveDiffStatus =
  url + "/api/LeaveRequest/GetLongLeaveDiffStatus";

//engagement
export const getEngagementMasterGridData =
  url + "/api/Engagement/GetEngagementMasterGridData";
export const InsertUpdateEngagementMasterData =
  url + "/api/Engagement/InsertUpdateEngagementMasterDetails";
export const getEngagementMasterDataById =
  url + "/api/Engagement/GetEngagementMasterById";
export const EngagementExportToExcel = url + "/api/Common/CommonExportToExcel";

//capacity
export const getCapacityAllocationGridData =
  url + "/api/CapicityAllocation/GetCapacityAllocationGridData";
export const insertUpdateCapacityAllocation =
  url + "/api/CapicityAllocation/InsertUpdateCapacityAllocation";
export const getCapacityAllocationById =
  url + "/api/CapicityAllocation/GetCapacityAllocationById";
export const getCapacityAllocationDataByEngagement =
  url + "/api/CapicityAllocation/GetCapacityAllocationDataByEngagement";
export const getAllocatedResourcePerMonthApiCall =
  url + "/api/CapicityAllocation/GetAllocatedResourcePerMonth";
export const getAllocatedMandaysPerMonthApiCall =
  url + "/api/CapicityAllocation/GetAllocatedMandaysPerMonth";
export const getTotalAllocatedMandaysApiCall =
  url + "/api/CapicityAllocation/GetTotalAllocatedMandays";
export const getTotalResourceAllocationApiCall =
  url + "/api/CapicityAllocation/GetTotalResourceAllocation";

export const getTotalAvailableMandays = `${url}/api/CapicityAllocation/GetTotalAvailableMandays`;

export const deleteResourceAllocated = `${url}/api/CapicityAllocation/DeleteAllocatedResource`;

export const getResourcePlannedLeave = `${url}/api/CapicityAllocation/ResourcePlannedLeave`;

export const getResourceWorkingDays = `${url}/api/EmployeeMaster/getEmployeWorkingDays`;

export const getCAID = `${url}/api/CapicityAllocation/UpdatePlannedHours`;

export const getRequirements = `${url}/api/CapicityAllocation/CheckForRequirement`;

//dashboard
export const getDashboardData = url + "/api/dashboard/getDashboardData";
export const getBackDatedData = url + "/api/dashboard/getBackDatedData";
export const insertUpdateDashboardData =
  url + "/api/dashboard/insertUpdateDashboardData";
export const insertTestCaseIssue = `${url}/api/Dashboard/TestCaseIssuedataInsert`;
export const getTCNatureOfIssueStatus = `${url}/api/Dashboard/getTCNatureOfIssueStatus`;
export const isSaturdayOrWeekendForDashboard = `${url}/api/Dashboard/IsSaturdayOrWeekendForDashboard`;
export const insertTestCasesHistory = `${url}/api/TestCase/insertTestCasesHistory`;
//Application Master

export const CheckIfApplicationExists =
  url + "/api/application/CheckIfApplicationExists";
export const InsertUpdateApplicationMasterData =
  url + "/api/application/insertUpdateApplicationMasterData";
export const getApplicationMasterGridData =
  url + "/api/application/getApplicationMasterGridData";
export const getApplicationByIdUrl =
  url + "/api/application/getApplicationById";
export const ApplicationExportToExcel = url + "/api/Common/CommonExportToExcel";

//cost Center
export const CheckIfCostCenterExists =
  url + "/api/costcenter/CheckIfCostCenterExists";
export const getCostCenterMasterGridData =
  url + "/api/costcenter/getCostCenterGridData";
export const getCostCenterByIdUrl = url + "/api/costcenter/getCostCenterById";
export const InsertUpdateCostCenterMasterData =
  url + "/api/costcenter/insertUpdatCostCenterData";
export const CostCenterExportToExcel = url + "/api/Common/CommonExportToExcel";

//phase Master
export const getPhaseDataUrl = url + "/api/phaseMaster/getPhaseMasterGridData";
export const InsertUpdatePhaseMasterData =
  url + "/api/phaseMaster/insertUpdatPhaseMasterData";
export const getPhaseByIdUrl = url + "/api/phaseMaster/getPhaseMasterById";
export const PhaseExportToExcel = url + "/api/Common/CommonExportToExcel";
export const getEngagementddPhases = `${url}/api/CommonDropdown/GetEngageMentForPhases`; //prashant

//Employee Master
export const getEmployeeMasterGridData =
  url + "/api/employeeMaster/getEmployeeMasterGridData";
export const InsertUpdateEmployeeMasterData =
  url + "/api/employeeMaster/insertUpdatEmployeeMasterData"; // added now
export const getEmployeeByIdUrl = url + "/api/employeeMaster/getEmployeeById";
export const EmployeeExportToExcel = url + "/api/Common/CommonExportToExcel";

export const EmployeeLeaveTypeData = `${url}/api/EmployeeMaster/getLeavebalanceforEmployee`;
export const DeleteInsertedLeave = `${url}/api/EmployeeMaster/DeleteInsertedLeave`;
export const GetCostCenter = `${url}/api/EmployeeMaster/GetCostCenter`; //Krishnam 31-05-2024
export const GetReportingManagers = `${url}/api/EmployeeMaster/GetReportingManagers`; //31-05-2024
export const GetEmployeeDashBoardData = `${url}/api/EmployeeMaster/GetEmployeeDashBoardData`; //03-05-2024
export const GetEmployeeExplortToExcel = `${url}/api/EmployeeMaster/ExportToExcel`; //03-05-2024
export const GetReportingManagerEmployee = `${url}/api/EmployeeMaster/GetReportingManagerEmployees`; //11 july 2024

//WorkPolicy Master

export const CheckIfWorkPolicyExists =
  url + "/api/WorkPolicies/CheckIfWorkPolicyExists";
export const getWorkPolicyDataUrl = url + "/api/WorkPolicies/getMasterGridData";
export const getWorkPolicyByIdUrl =
  url + "/api/WorkPolicies/getWorkPoliciesById";
export const InsertUpdateWorkPolicyData =
  url + "/api/WorkPolicies/insertUpdateWorkPoliciesMasterData";
export const getWorkPolicyHolidayList =
  url + "/api/workPolicies/getWorkPolicyHolidayList";
export const getWorkPolicyWorkdayList =
  url + "/api/workPolicies/getWorkPolicyWorkdayList";
export const getWorkPolicySaturdayList =
  url + "/api/workPolicies/getWorkPolicySaturdayList";
export const WorkPolicyExportToExcel = url + "/api/Common/CommonExportToExcel";

export const getWorkingSaturday = url + "/api/workPolicies/getWorkingSaturday";

//MileStone
export const getMilestoneDataByIdUrl =
  url + "/api/milestone/getMilestoneDataById";
export const getMilestoneDataUrl = url + "/api/milestone/getMilestoneData";
export const insertUpdateMilestoneDataUrl =
  url + "/api/milestone/insertUpdateMilestoneData";
export const CheckIfMilestoneExists =
  url + "/api/Milestone/CheckIfMilestoneExists";

export const getAutoPopulatedDataForTask =
  url + "/api/Task/AutoPopulateMandaysFields";

export const getAutoPopulatedDataForTicket =
  url + "/api/Ticket/AutoPopulateMandaysFields";

export const getAutoPopulatedAssignedHoursData =
  url + "/api/Task/AutoPopulateAssignedHoursFields";

export const getMilestoneFilterData =
  url + "/api/MileStone/GetMileStoneFilterData/";

export const mileStoneCarryForward =
  url + "/api/MileStone/MilestoneCarryForward/";

export const MilestoneExportToExcel = url + "/api/milestone/ExportToExcel";

//Timesheet Policy
export const getTimeSheetPolicyDataById =
  url + "/api/timesheet/GetTimeSheetById";
export const TimeSheetPolicyApi =
  url + "/api/timesheet/GetAllTimeSheetPolicyDetails";
export const insertUpdateTimeSheetPolicyData =
  url + "/api/timesheet/InsertUpdateTimeSheetPolicyDetails";
export const TimesheetExportToExcel = url + "/api/Common/CommonExportToExcel";

//calendar

export const getCalendarData = url + "/api/calendar/getCalendarData";
export const getMonthTaskDetails = url + "/api/calendar/getMonthTaskDetails";
export const gettotalworkingdays = url + "/api/calendar/getTotalworkingdays";

export const calendarExportToExcel = url + "/api/Calendar/ExportToExcel";

export const insertUpdateCalendarData =
  url + "/api/calendar/insertUpdateCalendarData";

// manager dashboard

export const getManagerDashboardData =
  url + "/api/ManagerDashboard/GetManagerDashboardData";

export const ExportToExcelApi = url + "/api/Common/ExportToExcel";
export const ExportToExcelTask = url + "/api/ManagerDashboard/ExportToExcel"; //prashant for task

export const ExportToExcelTicket = url + "/api/ManagerDashboard/ExportToExcelForTicket"; //yogesh for Ticket

export const getTaskDashboardGridData =
  url + "/api/ManagerDashboard/GetTaskDashboardData"; //prashant

export const getTicketDashboardGridData =
  url + "/api/ManagerDashboard/GetTicketDashboardData"; //yogesh

//reports
export const getCapacityUtilizationCustomerData = `${url}/api/CapacityUtilizationReport/GetCustomers`;

export const getCapacityUtilizationEngagementTypeOption = `${url}/api/CapacityUtilizationReport/GetEngagementType`;

export const getCapacityUtilizationEngagement = `${url}/api/CapacityUtilizationReport/GetEngagement`;

export const getCapacityAllocation = `${url}/api/CapacityUtilizationReport/GetCapacityAllocation`;

export const CapacityUtilizationReportExportToExcel = `${url}/api/Common/CapacityUtilizatonReportExportToExcel`;

export const GetResourceCapacityData = `${url}/api/ResourceCapacity/GetResourceCapacity`;

export const ExportToExcelResourceCapacity = `${url}/api/ResourceCapacity/ExportToExcel`;

export const getMileReportData = `${url}/api/MilestoneReport/GetMileStoneReportData`;

export const ExportToExcelMilestoneReport = `${url}/api/MilestoneReport/ExportToExcel`;

export const GetPeriodReportData = `${url}/api/Period/GetPeriodReport`;

export const GetSumPeriodReportData = `${url}/api/Period/GetSumPeriodReport`;

export const PeriodReportExportToExcel = `${url}/api/Period/ExportToExcel`;

export const NewPeriodReportExportToExcel = `${url}/api/Period/NewPeriodReportExportToExcel`;

export const GetInvoiceData = `${url}/api/ManagementCapacity/GetInvoiceMonth`;

export const GetCapacityDataManagerData = `${url}/api/ManagementCapacity/GetManagementReport`;

export const GetNonChargeableByReason = `${url}/api/ManagementCapacity/GetReason`;

export const GetCustomerReport = `${url}/api/ManagementCapacity/GetCustomerReport`;

export const ExportToExcelManagement = `${url}/api/ManagementCapacity/ExportToExcel`;

//POPendingReport

export const GetPOPendingReport = `${url}/api/POPendingReport/GetPOPendingReport`;

export const POPendingReportExportToExcel = `${url}/api/POPendingReport/ExportToExcel`;

//Traceability Matrix
export const getEngagementByLeadApi = `${url}/api/TestCase/GetEngagementsByLeads`;
export const getEngagementforTestCase = `${url}/api/TestCase/GetEngagementsforTestcases`;
export const TestCasesDownloadExcelTemplate = `${url}/api/TestCase/TestCaseDownloadTemplate`;
export const RequirementDownloadExcelTemplate = `${url}/api/Requirement_Traceability/RequirementDownloadTemplate`;
export const ReadDatafromExcel = `${url}/api/Requirement_Traceability/GetDatafromExcel`;
export const GetEngagementID = `${url}/api/Requirement_Traceability/GetEngagementID`;
export const GetGridData = `${url}/api/TestCase/GetTestCaseGridData`;
export const GetRequirementTitle = `${url}/api/TestCase/GetRequirementTitle`;
export const GetTestCaseStatus = `${url}/api/TestCase/GetTestCaseStatus`;
export const GetTestCaseByID = `${url}/api/TestCase/GetTestCaseByID`;
export const UpdateTestCases = `${url}/api/TestCase/updateTestCases`;
export const TestCaseInsert = `${url}/api/TestCase/InsertAndUpdateTask`;
export const getRequirementTracibilityGrid = `${url}/api/Requirement_Traceability/GetRequirementGridData/`;
export const getRequirementModalPopUp = `${url}/api/Requirement_Traceability/GetRequirementModalPopUp`;
export const getComplexityDropdown = `${url}/api/Requirement_Traceability/GetComplexityDropdown`;
export const getNonChargeableReasonDropdown = `${url}/api/Requirement_Traceability/GetNonChaChargableReasonDropdown`;
export const getAdditionalReasonDropdown = `${url}/api/Requirement_Traceability/GetAdditinalReasonDropdown`;
export const updatestatus = `${url}/api/Requirement_Traceability/UpdateStatus`;
export const updateRequirementTracebility = `${url}/api/Requirement_Traceability/UpdateRequirementTracebility`;
export const UpdateTestCaseStatus = `${url}/api/TestCase/updateTestCaseStatus`;
export const getEmployeeForTestCase = `${url}/api/TestCase/getEmployeesByCapacity`;
export const getPhases = `${url}/api/Requirement_Traceability/GetPhasesDD`; //Prashant
// Added a new endpoint for the person responsible for it, Raj Potdar , Date : 09-12-2024
export const getEmployeeResponsibleForTestCase = `${url}/api/TestCase/getEmployeeResponsiblle`;

//Task Assignment
export const getAutoPopulateRequirementHrs = `${url}/api/Task/GetRequrimentHrsDataForTaskCreation`;
export const getAutoPopulateRequirementTiltleDropdown = `${url}/api/Task/GetRequrimentDropdownDataForTaskCreation`;
export const getTaskID = `${url}/api/Task/CheckIfDataExist`;
export const EditTaskRecord = `${url}/api/Task/EditTaskRecord`;

//Task Ticket History
export const insertTaskHistory = `${url}/api/Task/insertTaskHistory`;
export const getTaskHistory = `${url}/api/Task/getTaskHistory`;
export const insertTicketHistory = `${url}/api/Ticket/insertTicketHistory`;
export const getTicketHistory = `${url}/api/Ticket/getTicketHistory`;
export const getTestCaseHistory = `${url}/api/TestCase/TestCaseHistoryModalPopup`;
export const getTicketDataById = `${url}/api/Ticket/getTicketDataById`;

//API FOR TEST CASES -------------------Yawar Ali
export const getEngagementForTestCases = `${url}/api/Dashboard/getEngForTCDashboard`;
export const getRequirementForTestCases = `${url}/api/Dashboard/getReqForTCDashboard`;
export const getTestCasesDashboard = `${url}/api/Dashboard/getTCDashboard`;
//Pinky for manager Engagmentdrop down
export const getEngagementManagerForTestCases = `${url}/api/Dashboard/getEngMgrForTCDashboard`;

//sangam for TestCaseIssueReport
export const getTestCaseIssueReport = `${url}/api/TestCaseIssueReport/GetTestCaseIssueReport`;
export const ExporttoExcelTestCaseIssuereport = `${url}/api/TestCaseIssueReport/ExportToExcel`;

//sangam for streamOptoins
export const getStreamOptions = `${url}/api/Engagement/GetStreamOptions`;

//sangam for billingMonthdd
export const getBillingMonths = `${url}/api/Engagement/GetBillingMonths`;

//sangam for getTicketTypeList
export const getTicketTypeList = `${url}/api/Dashboard/GetTicketTypes`;
//Krishnam for Team Structure

export const getUserHirerarchEmployee = `${url}/api/TeamStructure/GetTeamStructure`;
export const getUserHirerarchManagerEmployee = `${url}/api/TeamStructure/GetManagerDetails`;
export const getUserHierarchyEmployeeChildrens = `${url}/api/TeamStructure/GetUserChildren`;

//Krishnam for AMC Report
export const getAmcReport = `${url}/api/AmcReport/GetAmcReport`;
export const getCustomerData = `${url}/api/AmcReport/getCustomers`;
export const getEngagementDaya = `${url}/api/AmcReport/getEngagements`;
export const ExporttoExcelAmcReport = `${url}/api/AmcReport/ExportToExcel`;
export const getApplicationData = `${url}/api/AmcReport/getApplications`; //mahesh
//sangam for Workupload engagement
export const GetEngagementForWorkpacket = `${url}/api/WorkPacketUpload_tracibility/GetEngagementForWorkpacket`;
export const GetWorkPacketUploadTemplate = `${url}/api/WorkPacketUpload_tracibility/WorkPacketUploadDownloadTemplate`;
export const UploadWorkPacketUploadExcel = `${url}/api/WorkPacketUpload_tracibility/UploadExcel`;
export const getWorkPacketUploadTracibilityGrid = `${url}/api/WorkPacketUpload_tracibility/GetWorkPacketUploadGridData`;
export const getWorkPacketUploadTracibilityGridById = `${url}/api/WorkPacketUpload_tracibility/GetWorkPacketUploadGridDataById`;
export const getRequirement = `${url}/api/WorkPacketUpload_tracibility/GetRequirements`;
export const getAssignedsTo = `${url}/api/WorkPacketUpload_tracibility/GetAssignedTo`;
export const updateWorkPacketUploadGridData = `${url}/api/WorkPacketUpload_tracibility/UpdategridData`;

//Insert into MailLog if Task is unplanned
export const mailForIsUnplannedPlannedTask = `${url}/api/Task/InsertIfUnplanned`;

//<<<<<<< Updated upstream
//sangam 16-4-24
export const getStageOptions = `${url}/api/Engagement/GetStagesOptions`;
export const getFunctionOwnerOptions = `${url}/api/Engagement/GetFunctionOwners`;

//=======
//Prashant for EngagementStages
export const getEngagementDropdownForStage = `${url}/api/EngagementStages/GetEngagementDropdown`;
export const getStagesDropdown = `${url}/api/EngagementStages/GetStagesDropdown`;
export const InsertEngagementStagesHistoryData = `${url}/api/EngagementStages/InsertUpdateEngagementStageHistory`;
export const GetEngagementStageGridData = `${url}/api/EngagementStages/GetEngagementStagesGridData`;
export const getExportToExcelEngagementStages = `${url}/api/EngagementStages/ExportToExcel`;
export const GetMileStonesForStage = `${url}/api/EngagementStages/GetMileStones`; //added by mahesh to fetch milestiones
//>>>>>>> Stashed changes

//

//Prashant --RequirementReport--
export const getEngagementDropdownForRequirementReport = `${url}/api/RequirementReport/GetEngagementDropdown`;
export const getCustomerDropdownForRequirementReport = `${url}/api/RequirementReport/GetCustomerDropdown`;
export const getRequirmentReportGridData = `${url}/api/RequirementReport/GetRequirementReportGridData`;
export const GetRequirementReportExportToExcel = `${url}/api/RequirementReport/ExportToExcel`;
export const InsertUpdateEngagementStagesHistory = `${url}/api/EngagementStages/InsertUpdateIntoEngagementStagesHistory`;

//Krishnam for Engagement Report
export const getDashBoardDataForEngagementReport = `${url}/api/EngagementReport/GetDashBoardData`;
export const getCustomerDataForEngagementReport = `${url}/api/EngagementReport/GetCustomers`;
export const getStagesForEngagementReport = `${url}/api/EngagementReport/GetStages`;
export const getFunctionalOwnersforEngagementReport = `${url}/api/EngagementReport/GetFunctionalOwners`;
export const ExporttoExcelEngagementReport = `${url}/api/EngagementReport/ExportToExcel`;

//sangam for TraceabilityTestCaseIssueReport
export const GetEngagementForTestCaseIssue = `${url}/api/TestCaseIssue_tracibility/GetEngagementForTestCaseIssue`;
export const GetTestCaseIssueTemplate = `${url}/api/TestCaseIssue_tracibility/GetTestCaseIssueDownloadTemplate`;
export const UploadTestCaseIssueExcel = `${url}/api/TestCaseIssue_tracibility/UploadExcel`;
export const getTestCaseIssueGetGrid = `${url}/api/TestCaseIssue_tracibility/GetTestCaseIssueGridData`;
export const getTestCaseIssueTracibilityGridById = `${url}/api/TestCaseIssue_tracibility/GetTestCaseIssueGridDataById`;
export const getStatusOPtions = `${url}/api/TestCaseIssue_tracibility/GetStatusDD`;
export const getClassificationOptions = `${url}/api/TestCaseIssue_tracibility/GetClassificationDD`;
export const updateTestCaseIssueGridData = `${url}/api/TestCaseIssue_tracibility/UpdateTestCaseIssueData`;
export const responsiblePersonDropdown = `${url}/api/TestCaseIssue_tracibility/GetResponsiblePersonDropdown`;
export const getNonChargeableReasonForTestCaseIssue = `${url}/api/TestCaseIssue_tracibility/GetNonChargeableReasonForTestCaseIssue`;    //Deepak Gupta

//Krishnam for Enquiry
export const getEnquiryEngagementNames = `${url}/api/Enquiry/GetEngagementNames`;
export const getEnquiryCreateEngagement = `${url}/api/Enquiry/CreateEngagement`;
export const getEnquiryGridData = `${url}/api/Enquiry/GetGridDataForEnquiryEngagement`;
export const getEditScrennData = `${url}/api/Enquiry/GetEditScreenDataById`;
export const GetCustomerDropDown = `${url}/api/Enquiry/GetCustomerDropDown`;
export const EnquiryExportToExcel = `${url}/api/Enquiry/EnquiryExportToExcel`;
export const GetStream = `${url}/api/Enquiry/GetStreamOptions`; //Prashant

//Prashant For Purchase Order
export const getCustomers = `${url}/api/PurchaseOrder/GetCustomerDropdown`;
export const getEngagements = `${url}/api/PurchaseOrder/GetEngagementDropdown`;
export const getCurreny = `${url}/api/PurchaseOrder/GetCurrenyDropdown`;
export const InsertIntoPurchaseOrderMaster = `${url}/api/PurchaseOrder/InsertIntoPurchaseOrderMaster`;
export const PurchaseOrderFormGirdData = `${url}/api/PurchaseOrder/GetPurchaseOrderFormGirdData`;
export const PurchaseOrderFormGirdDataById = `${url}/api/PurchaseOrder/GetPurchaseOrderFormDataById`;
export const ExportToExcelPOForm = `${url}/api/PurchaseOrder/ExportToExcel`;
export const DeletePoFormMilestone = `${url}/api/PurchaseOrder/DeletePoFormMilestone`;
export const FileDownload = `${url}/api/PurchaseOrder/DownloadFileFromSharePoint`;
export const FileDownloadTestCaseIssue = `${url}/api/Dashboard/DownloadFileFromSharePoint`;
export const FileDownloadTCEngagementDetails = `${url}/api/Dashboard/TestCaseIssueEngagementDetails`;

//sangam  for MIlestone
export const getCustomersformilestone = `${url}/api/Milestone/GetCustomerDropdown`;
export const getPOData = `${url}/api/Milestone/GetPOData`;
export const getEngagementdd = `${url}/api/CommonDropdown/GetEngageMentForMileStone`;
export const getEngagementsdd = `${url}/api/CommonDropdown/GetAllEngageMentForMileStone`;
export const getCustomerDataByEngagement = `${url}/api/Milestone/GetCustomerData`;

//sangam for rating
export const getdataonDateChange = `${url}/api/Rating/GetDataForMonth`;
export const getCurrentEmpManagerDetails = `${url}/api/Rating/GetEmployeeManager`;
export const getManagerDropDown = `${url}/api/Rating/GetManagerDD`;
export const getLeadDropDown = `${url}/api/Rating/GetTLDropDown`;
export const getRatingDropDown = `${url}/api/Rating/GetRatingDropDown`;
export const getDatabyEngagementId = `${url}/api/Rating/GetDataByEngagementId`;
export const insertUpdateSelfRecored = `${url}/api/Rating/InsertUpdateSelfDetails`;
export const getSelfGridData = `${url}/api/Rating/GetSelfGridData`;
export const getSelfRatingDataById = `${url}/api/Rating/GetSelfDataByID`;
export const updateSelfDataById = `${url}/api/Rating/updateDataById`;
export const getLeadGridData = `${url}/api/Rating/GetLeadGridData`;
export const updateTLDataById = `${url}/api/Rating/UpdateTlRatingData`;
export const getLeadInnerGridData = `${url}/api/Rating/GetInnerLeadGridData`;
export const managerDashboardData = `${url}/api/Rating/GetManagerDashboardGridData`;
export const getManagerInnerGridData = `${url}/api/Rating/GetInnerManagerGridData`;
export const updateManagerDataById = `${url}/api/Rating/UpdatePMRatingData`;
export const CheckCostCenter = `${url}/api/Rating/CheckWhichCostCenter`;
export const insertUpdateForNonEngSelfRecored = `${url}/api/Rating/InsertUpdateForNoEngSelfDetails`;
export const updateWithoutEngSelfDataById = `${url}/api/Rating/UpdateForNonEngSelfData`;
export const getCalendarDataForEmp = `${url}/api/Rating/GetCalendarData`;
export const getTeamMembersDropDown = `${url}/api/Rating/GetTeamMembersList`;
export const getRatingStatusDropDown = `${url}/api/Rating/GetRatingStatusList`;
export const getKRADetails = `${url}/api/Rating/GetKRADetail`;

//For Productivity Master        --Deepak Gupta 
export const getEmployeeProductivityById =  `${url}/api/ProductivityMaster/GetEmployeeProductivityById`;
export const getEmployeeDropdown = `${url}/api/ProductivityMaster/GetEmployeeDropdown`;
export const getSkillSetDropdown = `${url}/api/ProductivityMaster/GetSkillSetDropdown`;
export const getLowProductivityReasonDropdown = `${url}/api/ProductivityMaster/GetLowProductivityReasonDropdown`;
export const getClassificationdropdown = `${url}/api/ProductivityMaster/GetClassificationdropdown`;
export const insertupdateProductivity = `${url}/api/ProductivityMaster/InsertupdateProductivity`;
export const getProductivityGridData = `${url}/api/ProductivityMaster/GetProductivityGridData`;
export const getProductivityByIdForEdit = `${url}/api/ProductivityMaster/GetProductivityByIdForEdit`;
export const exportToExcelProductivity = `${url}/api/ProductivityMaster/ExportProductivityToExcel`;
export const getProductivityInnerGridData = `${url}/api/ProductivityMaster/GetProductivityEngagementById`;



//Power Bi Report
export const getPowerBiReport = `${url}/api/PowerBI/GetEmbedInfo`;
export const getReportId = `${url}/api/PowerBI/GetReportId`; //Prashant

//for taskadhoc for checking capacity for manager and operational manager role

export const checkForCapacityallocation = `${url}/api/Task/CheckForCapacityallocation`;

// Comp-off Approval Omkar

//Risk Mitigation frontend-Prashant , backend-hetal
export const getEngagementForRisk = `${url}/api/RiskMitigation/GetEngagementDropdown`;
export const getResponsiblePersonsDropdown = `${url}/api/RiskMitigation/GetResponsiblePerson`;
export const getRMforEngagement = `${url}/api/RiskMitigation/getRiskMitigationsDetails`;
export const getRMStatusOptions = `${url}/api/RiskMitigation/getRMStatusOptions`;
export const InsertUpdateRiskMitigation = `${url}/api/RiskMitigation/InsertUpdateRiskMitigation`;
export const getRiskMitigationHistory = `${url}/api/RiskMitigation/GetRiskMitigationHistory`;
export const GetRiskMitigationGridData = `${url}/api/RiskMitigation/GetRiskMitigationGridData`;
export const getRiskDataById = `${url}/api/RiskMitigation/GetRiskMitigationDetailsById`;
export const ExportToExcelRiskMitigation = `${url}/api/RiskMitigation/ExportToExcel`;
export const getEngForMgrRiskMitigationDashboard = `${url}/api/RiskMitigation/GetEngForMgrRiskMitigationDashboard`;
export const getEngForRiskMitigationDashboard = `${url}/api/RiskMitigation/GetEngForRiskMitigationDashboard`;
export const ExportToExcelRiskMitigationHis = `${url}/api/RiskMitigation/ExportToExcelHis`;

// Comp-off Approval
export const CompOffApprovalDashboard = `${url}/api/CompOffLeave/GetCompOffDashboardData`;
export const GetCompOffDataBasedId = `${url}/api/CompOffLeave/GetCompOffDataBasedId`;
export const UpdateCompOffRequestData = `${url}/api/CompOffLeave/UpdateCompOffStatus`;
export const getMonthAndExpiry = `${url}/api/PurchaseOrder/GetPoMonthsAndExpiryDate`; //Prashant 26-11-2024

// KRADestails Omkar

export const GetKRADetailsDashboardData = `${url}/api/KRAUpdateDetail/GetKRADetailsDashboardData`;
export const GetAppLifeCycDropDown = `${url}api/KRAUpdateDetail/GetAppLifeCycDropDown`;
export const GetKraTypeDropdownData = `${url}api/KRAUpdateDetail/GetKraTypeDropdownData`;
export const GetEmployeeDropdownData = `${url}api/KRAUpdateDetail/GetEmpDropdownData`;
export const GetKRADetailsBasedOnId = `${url}api/KRAUpdateDetail/GetKRADetailsBasedOnId`;
export const InsertKRADetails = `${url}api/KRAUpdateDetail/InsertKRADetails`;
export const GetKRADetailsExcelData = `${url}/api/KRAUpdateDetail/GetKRADetailsExcelData`;
// Added a new api call for the tempdata insert for the self rating, Raj Potdar, Date : 15-11-2024
export const addTempSelfRatingDetails = `${url}/api/Rating/AddTempSelfRatingDetails`;
export const gettempselfratingdetials = `${url}/api/Rating/GetTempSelfRatingDetails`;
export const insertUpdatedraftForNonEngSelfRecored = `${url}/api/Rating/InsertUpdateDraftForNoEngSelfDetails`;
export const insertUpdatedraftSelfRecored = `${url}/api/Rating/InsertUpdateDraftSelfDetails`;
// Added a new API for validation of the new joining, Raj Potdar, Date : 25-11-2024
export const getemployeedateofjoiningdeatial = `${url}/api/Rating/GetUserDateOfJoining`;
// export const getratingstatusbydetailid = `${url}/api/Rating/GetRatingStatus`;

export const ExporttoExcelTracibilityRequirement = `${url}/api/Requirement_Traceability/ExporttoExcelTracibilityRequirement`;
export const ExporttoExcelTTraceabilityTestCases = `${url}/api/TestCase/ExporttoExcelTTraceabilityTestCases`;
export const ExporttoExcelTTraceabilityWorkPacket = `${url}/api/WorkPacketUpload_tracibility/ExporttoExcelTTraceabilityWorkPacket`;
export const ExporttoExcelTTraceabilityIssueUpload = `${url}/api/TestCaseIssue_tracibility/ExporttoExcelTTraceabilityIssueUpload`;
export const GetEmployeeLeavesData = `${url}/api/LeaveRequest/GetEmployeeLeavesData`;

//WorkPolicyHoliday Deepak Gupta, Amogh
export const PolicyHolidayDashboardData =`${url}/api/WorkPolicyHoliday/PolicyHolidayDashboardData`;
export const GetPolicyHolidayDetailsByID = `${url}/api/WorkPolicyHoliday/GetPolicyHolidayDetailsByID`;
export const DeletePolicyHoliday = `${url}/api/WorkPolicyHoliday/DeletePolicyHoliday`;
export const InsertUpdatePolicyHoliday = `${url}/api/WorkPolicyHoliday/InsertUpdatePolicyHoliday`;
export const GetAllHolidaysByPolicyID = `${url}/api/WorkPolicyHoliday/GetAllHolidaysByPolicyID`;
export const getHolidayFromPolicyHoliday = `${url}/api/WorkPolicyHoliday/GetHolidayFromPolicyHoliday`;

//added by kausher and yogesh
export const exporttoExcelPolicyHoliday =`${url}api/WorkPolicyHoliday/ExportWorkPoliciesToExcel`;

//add by yogesh
export const getTicketDownloadData =`${url}api/Ticket/getEngagementDetailsForUrl`;
export const FileDownloadTicket =`${url}api/ManagerDashboard/DownloadFileForTicket`;
export const getTicketData =`${url}api/Ticket/GetTicketData`;

export const Logout = `${url}api/Login/logout`;

export const getEngagementMilestoneValue = url + "/api/milestone/GetEngagementMilestoneValue";
